import React from 'react'
import { FEATURE_UC_IN_WEBREGISTER_POPOVER } from '../../../../../../constants'
import { getFeatureFromCache } from '../../../../../../util/feature-cache'
import { LineItemFulfilmentFixSaleAddresses as LineItemFulfilmentFixSaleAddressesUnified } from './LineItemFulfilmentFixSaleAddresses'
import { LineItemFulfilmentFixSaleAddressesLegacy } from './LineItemFulfilmentFixSaleAddressesLegacy'

export const LineItemFulfilmentFixSaleAddresses: React.FC = () => {
  const isUnifiedFulfilmentUiEnabled = getFeatureFromCache(
    FEATURE_UC_IN_WEBREGISTER_POPOVER
  )

  return isUnifiedFulfilmentUiEnabled ? (
    <LineItemFulfilmentFixSaleAddressesUnified />
  ) : (
    <LineItemFulfilmentFixSaleAddressesLegacy />
  )
}
